App.filter('dateFormatterLongNameDay', function () {
    return function (miliSec) {
        miliSec = miliSec || '';
        if (miliSec) {
            var time = new Date(miliSec);

            var nameOfDay = nameDay(time.getDay());

            var all = nameOfDay;
        }
        return all;

        function nameDay(numberOfDay) {
        	var array = new Array(7);
        	array[1] = 'Poniedziałek';
			array[2] = 'Wtorek';
			array[3] = 'Środa';
			array[4] = 'Czwartek';
			array[5] = 'Piątek';
			array[6] = 'Sobota';
			array[0] = 'Niedziela';

			return array[numberOfDay];
        }
    };
})